/** The public cashier portal is a separate host from the player and operations sites. */
export function isBookiesHost(hostname: string): boolean {
  return hostname.toLowerCase().startsWith("bookies.");
}
